// src/hooks/useExploreWithReference.js
//
// Explore's with_reference for useEntitledFootprints (S-c4): see
// layers/imagery/referenceOnTop.js for when a Sentinel-2 dataset is sent.
import { useMemo } from "react";
import { useImageryStackStore } from "../stores/useImageryStackStore";
import { exploreWithReference } from "../layers/imagery/referenceOnTop";

export function useExploreWithReference() {
  const stack = useImageryStackStore((s) => s.stack);
  const catalog = useImageryStackStore((s) => s.catalog);
  const cursor = useImageryStackStore((s) => s.cursor);
  const compareMode = useImageryStackStore((s) => s.compareMode);
  return useMemo(() => exploreWithReference({ stack, cursor, catalog, compareMode }), [stack, cursor, catalog, compareMode]);
}
